import { useContext } from 'react';

import AppContext from '@/contexts/appContext';
import { QueryParams } from '@/types/query';
import StaffEnrollment from '@/types/staffEnrollment';
import ajax from '@/utils/ajax';

export const staffEnrollmentRepository = {
  BASE_PATH: '/api/dugout/staff_enrollments/',

  async getStaffEnrollments({
    host,
    params
  }: {
    host: string;
    params: QueryParams;
  }): Promise<StaffEnrollment[]> {
    const path = this.BASE_PATH;
    const response = await ajax.get({
      url: `${host}${path}`,
      params
    });

    return response.data;
  },

  async getStaffEnrollment({
    host,
    staffId,
    personId,
    jurisdiction,
    insuranceProvider,
    insuranceType,
    programScope,
    debug = false,
    onlyActive = true
  }: {
    host: string;
    staffId: string;
    personId?: string;
    jurisdiction?: string;
    insuranceProvider?: string;
    insuranceType?: string;
    programScope?: string;
    debug?: boolean;
    onlyActive?: boolean;
  }): Promise<StaffEnrollment> {
    const path = `${this.BASE_PATH}${staffId}/`;
    const params: Record<string, string> = {
      ...(debug && { debug: 'true' }),
      only_active: String(onlyActive)
    };

    if (personId) params.person_id = personId;
    if (jurisdiction) params.jurisdiction = jurisdiction;
    if (insuranceProvider) params.insurance_provider = insuranceProvider;
    if (insuranceType) params.insurance_type = insuranceType;
    if (programScope) params.program_scope = programScope;

    const response = await ajax.get({
      url: `${host}${path}`,
      params
    });

    return response.data;
  }
};

const StaffEnrollmentRepository = () => {
  const { host } = useContext(AppContext);

  return {
    async getStaffEnrollments(params: QueryParams): Promise<StaffEnrollment[]> {
      return staffEnrollmentRepository.getStaffEnrollments({
        host,
        params
      });
    },

    async getStaffEnrollment(
      staffId: string,
      personId?: string,
      debug?: boolean,
      manualParams?: {
        jurisdiction?: string;
        insuranceProvider?: string;
        insuranceType?: string;
        programScope?: string;
        onlyActive?: boolean;
      }
    ): Promise<StaffEnrollment> {
      return staffEnrollmentRepository.getStaffEnrollment({
        host,
        staffId,
        personId,
        debug,
        ...manualParams
      });
    }
  };
};

export default StaffEnrollmentRepository;
